import React, { useState } from "react";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import DSPrimaryButton from "../../system-design/DSPrimaryButton";
import DSCircularProgress from "../../system-design/DSCircularProgress";
import { KlydoError } from "../../../components/hooks/types";
import ConfirmationModal from "../../ConfirmationModal";

type LoadKlydosButtonProps = {
  onLoadKlydos: () => void;
  klydosLoading: boolean;
  klydosError: KlydoError | null;
  klydosLoaded: boolean;
  disabled?: boolean;
};

const LoadKlydosButton = ({
  onLoadKlydos,
  klydosLoading,
  klydosError,
  klydosLoaded,
  disabled = false,
}: LoadKlydosButtonProps) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleButtonClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    setShowConfirmation(false);
    onLoadKlydos();
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  return (
    <DSBox sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <DSPrimaryButton
        onClick={handleButtonClick}
        disabled={klydosLoading || klydosLoaded || disabled}
        startIcon={klydosLoading ? <DSCircularProgress size={20} /> : undefined}
        sx={{ alignSelf: "flex-start" }}
      >
        {klydosLoaded ? "Klydos Loaded" : "Load Klydos"}
      </DSPrimaryButton>

      {klydosError && (
        <DSTypography variant="body2" color="error">
          Error loading klydos: {klydosError.message || "Unknown error"}
        </DSTypography>
      )}

      <ConfirmationModal
        open={showConfirmation}
        message="This action may take a while. Are you sure you want to continue?"
        onClose={handleCancel}
        onConfirm={handleConfirm}
      />
    </DSBox>
  );
};

export default LoadKlydosButton;
